module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "id": "down"
    },
    on: {
      "click": _vm.next
    }
  }, [_c('icon', {
    staticClass: "angle-down",
    attrs: {
      "name": "angle-down",
      "scale": "4"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b378ae1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonDown.vue
// module id = 122
// module chunks = 1